function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChalkboardteacher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75a1.502 1.502 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5h1.255a.75.75 0 00.678-.428 4.502 4.502 0 018.134 0 .75.75 0 00.678.428h5.755a1.502 1.502 0 001.5-1.5V5.25a1.502 1.502 0 00-1.5-1.5zm-10.5 12a3 3 0 110-6 3 3 0 010 6zm10.5 3h-5.303a5.991 5.991 0 00-1.235-1.5H18a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75v9a.75.75 0 00.565.726c-.502.435-.929.95-1.262 1.524H3.75V5.25h16.5v13.5z",
    fill: props.fill
  }));
}

export default SvgChalkboardteacher;